// extracted by mini-css-extract-plugin
module.exports = {"LoginButton":"login-button_LoginButton__D5wdc","LoginButton__mobile":"login-button_LoginButton__mobile__D8UqQ","LoginButton__desktop":"login-button_LoginButton__desktop__6os5A"};